import { cn } from '../../lib/utils';

interface SummaryCellProps {
  label: string;
  value: string;
  mono?: boolean;
  highlight?: boolean;
}

/** Three-up summary cell used in the contractor dashboard header (Base / Expenses / Total). */
export function SummaryCell({ label, value, mono, highlight }: SummaryCellProps) {
  return (
    <div>
      <div className="text-[11px] uppercase tracking-wide text-foreground-muted font-medium">{label}</div>
      <div
        className={cn(
          'mt-1',
          mono && 'font-mono',
          highlight ? 'text-primary text-base font-bold' : 'text-[15px] font-medium',
        )}
      >
        {value}
      </div>
    </div>
  );
}
